<div ngxUiLoaderBlurred blur="10"></div>
<ngx-ui-loader [fgsType]="'three-strings'" [fgsColor]="'#92c37c'" [pbColor]="'#92c37c'"></ngx-ui-loader>